import { DateTime } from 'luxon';
import { orderBy, toNumber } from 'lodash-es';
import { BigNumber } from 'bignumber.js';
import type {
  GqlShareholder,
  GqlShareTransactionGroup,
  GqlShareTransaction,
  GqlTransactionKind,
  GqlSnrShareCapitalChange,
} from '../graphql/base-types.graphql';

export interface GqlShareTransactionPlus
  extends Omit<
    GqlShareTransaction,
    'blockStart' | 'blockEnd' | 'shareTransactionGroup' | 'shareTransactionDocuments' | 'buyer' | 'seller'
  > {
  date: DateTime;
  kind: GqlTransactionKind;
  sortOrder: number;
  splitFactor?: BigNumber;
  blockStart: number;
  blockEnd: number;
  snrShareCapitalChangeId: string | null | undefined;
  buyerIdentityId: string | undefined;
  sellerIdentityid: string | undefined;
}

export function stgsToStsPlus(
  stgs: (Pick<
    GqlShareTransactionGroup,
    'id' | 'transactionDate' | 'sortOrder' | 'snrShareCapitalChangeId' | 'kind' | 'splitFactor'
  > & {
    shareTransactions: (Omit<
      GqlShareTransaction,
      'shareTransactionGroup' | 'shareTransactionDocuments' | 'buyer' | 'seller'
    > & {
      buyer?: Pick<GqlShareholder, 'identityId'> | null;
      seller?: Pick<GqlShareholder, 'identityId'> | null;
    })[];
    snrShareCapitalChange?: Pick<GqlSnrShareCapitalChange, 'id' | 'currency'> | null;
  })[],
): GqlShareTransactionPlus[] {
  const sortedStgs = orderBy(stgs, [stg => stg.transactionDate, stg => stg.sortOrder], ['asc', 'asc']);
  return sortedStgs.flatMap(stg => {
    return stg.shareTransactions.map(st => {
      return {
        ...st,
        snrShareCapitalChangeId: stg.snrShareCapitalChangeId,
        date: DateTime.fromISO(stg.transactionDate),
        kind: stg.kind,
        sortOrder: stg.sortOrder,
        splitFactor: stg.splitFactor ? new BigNumber(stg.splitFactor) : undefined,
        blockStart: toNumber(st.blockStart),
        blockEnd: toNumber(st.blockEnd),
        buyerIdentityId: st.buyer?.identityId,
        sellerIdentityid: st.seller?.identityId,
      } satisfies GqlShareTransactionPlus;
    });
  });
}
